import React, {useState} from 'react';
import {Box, Typography, useTheme} from '@mui/material';
import {CheckCircle, Dot, WrongCircle} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const passwordMatchContent = [
  {
    title: '6-32 characters, no spaces',
    status: '',
    type: 'limit',
  },
];

export const useValidateComponent = (
  authlistener?: boolean
): [(password: string) => void, React.FC] => {
  const [passwordContent, setPasswordContent] = useState(passwordMatchContent);

  const handlePasswordRegexValidation = (password: string) => {
    const REGEX_MAP: {[key: string]: RegExp} = {
      limit: /^\S{6,32}$/,
    };

    passwordContent.forEach(content => {
      const valid = REGEX_MAP[content.type].test(password?.trim());
      content['status'] = valid ? CheckCircle : WrongCircle;
    });
  };

  const theme = useTheme();
  const Component: React.FC = () => (
    <Box p={!isAppIimjobs && authlistener ? '15px 20px' : '0px'}>
      <Typography
        variant="caption"
        fontWeight={theme.typography.fontWeightBold}
        fontSize={!isAppIimjobs && authlistener ? '14px' : '10px'}
      >
        Your password must include:
      </Typography>
      <Box
        sx={{
          paddingLeft: !isAppIimjobs && authlistener ? 0 : 1,
          mt: 0.5,
        }}
      >
        {passwordContent.map(content => (
          <Box
            key={`${content.type}_index`}
            display={'flex'}
            alignItems={'center'}
            sx={{
              paddingLeft: 0,
              paddingTop: 1,
            }}
          >
            <Image
              src={content.status || Dot}
              alt={'check'}
              width={
                content.status ? 10 : !isAppIimjobs && authlistener ? 10 : 8
              }
              height={
                content.status ? 10 : !isAppIimjobs && authlistener ? 10 : 8
              }
            />
            <Typography
              variant="caption"
              ml={!isAppIimjobs && authlistener ? 1.25 : 0.5}
              fontSize={!isAppIimjobs && authlistener ? '14px' : '10px'}
            >
              {content.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return [handlePasswordRegexValidation, Component];
};
